import React, { useMemo } from 'react';
import { Button } from "tea-component";
import { getLocale, useIntl } from 'umi';
import { ACCESS_LINK, IS_GLOBAL } from '@/pages/home/_config/config';
import './index.scss';

export default (props: any) => {
  let { type = 'permission', gameCode, message = '', showButton = true, callback } = props;
  const { formatMessage } = useIntl()
  
  const textTips = useMemo(()=>{
    return IS_GLOBAL ? formatMessage({id:"common_global_no_game_permission"}) : formatMessage({id:"common_woa_no_game_permission"}) 
  },[getLocale()])

  const handleRequestAccess = () => {
    const url = `${ACCESS_LINK}&role_name=game_level_3&module=${gameCode}`;
    window.open(url);
  }

  return (
    <div className='no-permission-container'>
      <div className='no-permission-box'>
        <div className='no-permission-img'></div>
        <div className='no-permission-tips'>{message || textTips}</div>
        {showButton && <Button
          type="primary"
          onClick={callback || handleRequestAccess}
        >
          {formatMessage({ id: 'game_selector_request_access' })}
        </Button>}
      </div>
    </div>
  );
};
